'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CheckOutlined = _interopRequireDefault(require('./lib/icons/CheckOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _CheckOutlined;
exports.default = _default;
module.exports = _default;